import { ITableCol } from '@data/interfaces/itable.interface';

/**
 * Constantes para el módulo de Campañas del sistema Dripping
 * Define columnas de tabla, acciones disponibles y configuraciones
 */

// ============= OPCIONES DE ESTADO =============
export const CAMPAIGN_STATUS_OPTIONS = [
  { value: 'PENDING', label: 'Pendiente' },
  { value: 'COMPLETED', label: 'Completada' },
  { value: 'FAILED', label: 'Fallida' },
  { value: 'CANCELLED', label: 'Cancelada' }
];

export const CAMPAIGN_STATUS_ENUM = {
  PENDING: 'Pendiente',
  COMPLETED: 'Completada',
  FAILED: 'Fallida',
  CANCELLED: 'Cancelada'
};

export const CAMPAIGN_STATUS_COLOR_ENUM = {
  PENDING: 'warning',
  COMPLETED: 'success',
  FAILED: 'danger',
  CANCELLED: 'secondary'
};

// ============= COLUMNAS DE LA TABLA =============
export const CAMPAIGN_COLUMNS: ITableCol[] = [
  { 
    type: 'text', 
    field: '_id', 
    header: 'ID', 
    showFilter: false, 
    dataType: 'link', 
    linkField: '_id', 
    rootLink: 'dripping/campaigns' 
  },
  { 
    type: 'text', 
    field: 'strategyName', 
    header: 'Estrategia', 
    showFilter: true 
  },
  { 
    type: 'text', 
    field: 'leaseNumber', 
    header: 'Lease', 
    showFilter: true 
  },
  { 
    type: 'text', 
    field: 'clientName', 
    header: 'Cliente', 
    showFilter: true 
  },
  { 
    type: 'date', 
    field: 'scheduledDate', 
    header: 'Fecha Programada', 
    showFilter: true, 
    dataType: 'date' 
  },
  { 
    type: 'enum', 
    field: 'status', 
    header: 'Estado', 
    showFilter: true, 
    dataType: 'enum', 
    enum: CAMPAIGN_STATUS_ENUM, 
    enumColor: CAMPAIGN_STATUS_COLOR_ENUM, 
    options: CAMPAIGN_STATUS_OPTIONS 
  },
  { 
    type: 'text', 
    field: 'channelsDisplay', 
    header: 'Canales', 
    showFilter: false 
  },
  { 
    type: 'text', 
    field: 'resultsDisplay', 
    header: 'Resultado', 
    showFilter: false 
  },
  { 
    type: 'date', 
    field: 'createdAt', 
    header: 'Creada', 
    showFilter: true, 
    dataType: 'date' 
  }
];

// ============= ACCIONES DE LA TABLA =============
export const CAMPAIGN_ACTIONS = [
  {
    title: 'Ejecutar Ahora',
    icon: 'fa-solid fa-play-circle',
    action: 'EXECUTE_NOW',
    color: 'success',
    permission: ['dripping', 'execute'] as [string, string],
    rule: { field: 'status', value: 'PENDING', type: 'equals' }
  },
  {
    title: 'Cancelar',
    icon: 'fa-solid fa-ban',
    action: 'CANCEL',
    color: 'danger',
    permission: ['dripping', 'delete'] as [string, string],
    rule: { field: 'status', value: 'PENDING', type: 'equals' }
  }
];

// ============= INFORMACIÓN DE ESTADOS =============
export const STATUS_INFO = {
  PENDING: {
    label: 'Pendiente',
    icon: 'fa-solid fa-clock',
    color: '#FFA726',
    description: 'Campaña programada, esperando ejecución'
  },
  COMPLETED: {
    label: 'Completada',
    icon: 'fa-solid fa-check-circle',
    color: '#66BB6A',
    description: 'Campaña completada exitosamente'
  },
  FAILED: {
    label: 'Fallida',
    icon: 'fa-solid fa-exclamation-circle',
    color: '#EF5350',
    description: 'Campaña falló durante ejecución'
  },
  CANCELLED: {
    label: 'Cancelada',
    icon: 'fa-solid fa-times-circle',
    color: '#78909C',
    description: 'Campaña cancelada manualmente'
  }
};

// ============= CONFIGURACIÓN DE MÉTRICAS =============
export const METRICS_CONFIG = [
  { 
    key: 'totalSent', 
    label: 'Total Enviados', 
    icon: 'fa-solid fa-paper-plane', 
    color: '#42A5F5' 
  },
  { 
    key: 'successful', 
    label: 'Exitosos', 
    icon: 'fa-solid fa-check', 
    color: '#66BB6A' 
  },
  { 
    key: 'failed', 
    label: 'Fallidos', 
    icon: 'fa-solid fa-times', 
    color: '#EF5350' 
  },
  { 
    key: 'pending', 
    label: 'Pendientes', 
    icon: 'fa-solid fa-clock', 
    color: '#FFA726' 
  }
];

// ============= ICONOS DE CANALES =============
export const CHANNEL_ICONS = {
  EMAIL: 'fa-solid fa-envelope',
  SMS: 'fa-solid fa-comment-sms',
  WHATSAPP: 'fa-brands fa-whatsapp',
  CALL: 'fa-solid fa-phone'
};

// ============= COLORES DE ESTADO DE CANAL =============
export const CHANNEL_STATUS_COLORS = {
  PENDING: '#FFA726',
  SCHEDULED: '#42A5F5',
  SENDING: '#42A5F5',
  SENT: '#66BB6A',
  FAILED: '#EF5350'
};
